import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const CallInProgressModalStyleParts = [
  'bodyContainer',
  'icon',
  'headerText',
  'bodyText',
  'footerContainer',
] as const

const helpers = createMultiStyleConfigHelpers(CallInProgressModalStyleParts)

export const CallInProgressModalStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      paddingY: '0.25rem',
      paddingX: '1rem',
      gap: '0',
      alignItems: 'center',
    },
    icon: {
      boxSize: '2rem',
      paddingBottom: '0.5rem',
    },
    headerText: {
      ...textStyles[textStyleKeys.Body1_Bold],
    },
    bodyText: {
      ...textStyles[textStyleKeys.Body1],
      textAlign: 'center',
    },
    footerContainer: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '0.62rem',
    },
  },
})

export const useCallInProgressModalStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(
    CallInProgressModalStyle,
    props,
  ) as MultiStyleType<typeof CallInProgressModalStyleParts>
}
